import { render, staticRenderFns } from "./orderForDetail copy.vue?vue&type=template&id=631364a0&scoped=true&"
import script from "./orderForDetail copy.vue?vue&type=script&lang=js&"
export * from "./orderForDetail copy.vue?vue&type=script&lang=js&"
import style0 from "./orderForDetail copy.vue?vue&type=style&index=0&id=631364a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631364a0",
  null
  
)

export default component.exports